import { render, staticRenderFns } from "./TaskColumnSelectorDisplay.vue?vue&type=template&id=618b58d2"
import script from "./TaskColumnSelectorDisplay.vue?vue&type=script&lang=js"
export * from "./TaskColumnSelectorDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports